import { render, staticRenderFns } from "./BfChart.vue?vue&type=template&id=81cbf07a&lang=pug"
import script from "./BfChart.vue?vue&type=script&lang=js"
export * from "./BfChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports